import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arr-back",
  "use": "arr-back-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"arr-back\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.707 22.707a1 1 0 0 0 1.414-1.414L11.83 17H23a1 1 0 1 0 0-2H11.829l4.292-4.293a1 1 0 0 0-1.414-1.414L8 16l6.707 6.707Z\" fill=\"#3B3F3D\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol